<script>
</script>

<section class="trip-outro">
  <p>Goodbye!</p>
</section>

<style>
  .trip-outro {
    position: relative;
    width: 100%;
    margin-block-start: 60%;
    padding-block-end: var(--spacer-lg);

    text-align: center;
  }
</style>
